import React from 'react';
import styled from 'styled-components';

const PillTabElement = styled.button<{ selected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.8rem 1.6rem;
  border-radius: 2rem;
  border: 1px solid ${({ selected, theme }) => (selected ? theme.vars.newColor.blue1 : theme.vars.newColor.lightGS1)};
  background-color: ${({ selected, theme }) => (selected ? theme.vars.newColor.blue1 : 'transparent')};
  color: ${({ selected, theme }) => (selected ? theme.vars.newColor.white : theme.vars.newColor.darkGS2)};
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in;
  white-space: nowrap;
  outline: none;

  &:hover {
    background-color: ${({ selected, theme }) => (selected ? theme.vars.newColor.blue1 : theme.vars.newColor.lightGS2)};
    border-color: ${({ selected, theme }) => (selected ? theme.vars.newColor.blue1 : theme.vars.newColor.lightGS1)};
  }

  &:focus {
    box-shadow: 0 0 0 2px ${({ theme }) => theme.vars.newColor.blue2}40;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export interface PillTabProps {
  id: string;
  label: string;
  selected: boolean;
  onClick: (id: string) => void;
  disabled?: boolean;
  'aria-label'?: string;
}

export const PillTab: React.FC<PillTabProps> = ({
  id,
  label,
  selected,
  onClick,
  disabled = false,
  'aria-label': ariaLabel,
}) => {
  const handleClick = () => {
    if (!disabled) {
      onClick(id);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if ((e.key === 'Enter' || e.key === ' ') && !disabled) {
      e.preventDefault();
      onClick(id);
    }
  };

  return (
    <PillTabElement
      role="tab"
      aria-selected={selected}
      aria-label={ariaLabel || label}
      selected={selected}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      tabIndex={disabled ? -1 : 0}
    >
      {label}
    </PillTabElement>
  );
};
